import Vue from 'vue'
import _ from 'lodash'

const nailDesignsAll = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.nailDesigns.all}`, { params: payload })
}

const nailDesignTagsAll = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.nailDesigns.tags.all}`, { params: payload })
}

export default {
  GET_NAIL_DESIGNS: ({ commit, state }, { params = {}, callback = null }) => {
    return nailDesignsAll(params).then(response => {
      const data = response.data.data
      const nailDesigns = _.map(data, item => {
        item.opened = true
        return item
      })
      commit('setNailDesigns', state.nailDesigns.concat(nailDesigns))

      callback ? callback(_.cloneDeep(nailDesigns)) : null
    })
  },
  GET_NAIL_DESIGN_TAGS: ({ commit, state }, { params = {}, callback = null }) => {
    return nailDesignTagsAll(params).then(response => {
      const data = response.data.data
      const nailDesignTags = _.map(data, item => {
        item.opened = true
        return item
      })
      commit('setNailDesignTags', nailDesignTags)

      callback ? callback(_.cloneDeep(nailDesignTags)) : null
    })
  },
}
